module.exports = __webpack_public_path__ + "img/84ne.9d114f06.svg";